import React, { useContext, useEffect } from 'react'
import queryString from 'query-string'
import useApplyDiscountCode from '../../hooks/useApplyDiscountCode'
import useReplaceLineItem from '../../hooks/useReplaceLineItem'
import useReplaceLineItems from '../../hooks/useReplaceLineItems'
import { useShopify } from '../../contexts/shopify'
import { LayoutContext } from '../../contexts'

const AddDiscountToCart = ({ location }) => {
  const { storeSubdomain } = useContext(LayoutContext)
  const { checkouts: allCheckouts } = useShopify()
  const checkouts = allCheckouts[storeSubdomain]
  const [replaceLineItem, { loading }] = useReplaceLineItem()
  const [replaceLineItems, { error }] = useReplaceLineItems()
  const applyDiscountCode = useApplyDiscountCode()

  const addProductToCart = async (variantId, quantity) => {
    await replaceLineItem({
      variantId: variantId,
      quantity: quantity,
    })
  }

  const addProductsToCart = async (productArray) => {
    await replaceLineItems(productArray)
  }

  useEffect(() => {
    const discountCode = queryString.parse(location.search)['discount']
    const discountProductVariant = queryString.parse(location.search)['product']
    // const discountProductQuantity = queryString.parse(location.search)[
    //   'quantity'
    // ]
    if (discountCode && checkouts.id) {
      setCartOpen(true)
      setTimeout(() => applyDiscountCode(discountCode, checkouts), 500)
    }
    if (discountProductVariant && checkouts.id) {
      if (Array.isArray(discountProductVariant)) {
        addProductsToCart(
          discountProductVariant.map((variantId) => ({
            variantId,
            quantity: 1,
          })),
        )
        setCartOpen(true)
      } else {
        const inCartQuantity =
          checkouts.lineItems.edges.find(
            ({
              node: {
                variant: { id },
              },
            }) => id === discountProductVariant,
          )?.node.quantity || 0

        addProductToCart(discountProductVariant, 1 + inCartQuantity)
        setCartOpen(true)
      }
    }
  }, [checkouts.id])

  return null
}

export default AddDiscountToCart
